import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Processando autorização...');

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      if (error) {
        setStatus('error');
        setMessage(`Erro do Google: ${error}`);
        return;
      }

      if (!code) {
        setStatus('error');
        setMessage('Código de autorização não encontrado na URL.');
        return;
      }

      try {
        const { data, error: fnError } = await supabase.functions.invoke('google-oauth-callback', {
          body: { code, state }
        });

        if (fnError) throw fnError;

        if (data?.success) {
          setStatus('success');
          setMessage('Google conectado com sucesso! Você pode fechar esta janela.');
          // Notifica a janela principal que conectou
          if (window.opener) {
            window.opener.postMessage({ type: 'GOOGLE_OAUTH_SUCCESS' }, '*');
          }
        } else {
          throw new Error(data?.error || 'Erro desconhecido');
        }
      } catch (e: any) {
        setStatus('error');
        setMessage(`Erro ao conectar: ${e.message || 'Tente novamente.'}`);
      }
    };

    processCallback();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#F6F6F4] flex items-center justify-center px-4">
      <div className="max-w-sm w-full bg-white rounded-2xl border border-gray-100 p-8 text-center">
        <div className="w-14 h-14 flex items-center justify-center bg-[#E8610A]/10 rounded-xl mx-auto mb-4">
          {status === 'loading' && (
            <i className="ri-google-fill text-[#E8610A] text-2xl animate-spin"></i>
          )}
          {status === 'success' && (
            <i className="ri-checkbox-circle-fill text-green-500 text-2xl"></i>
          )}
          {status === 'error' && (
            <i className="ri-error-warning-fill text-red-500 text-2xl"></i>
          )}
        </div>

        <h1 className="text-lg font-bold text-gray-900 mb-2">
          {status === 'loading' && 'Conectando Google...'}
          {status === 'success' && 'Conectado!'}
          {status === 'error' && 'Ops, algo deu errado'}
        </h1>

        <p className="text-sm text-gray-500 mb-6">{message}</p>

        {status === 'success' && (
          <button
            onClick={() => window.close()}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-5 py-3 rounded-xl hover:bg-[#C4500A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-close-line"></i>
            Fechar janela
          </button>
        )}

        {status === 'error' && (
          <button
            onClick={() => navigate('/painel-pedidos')}
            className="w-full inline-flex items-center justify-center gap-2 bg-gray-100 text-gray-700 text-sm font-semibold px-5 py-3 rounded-xl hover:bg-gray-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar ao painel
          </button>
        )}
      </div>
    </div>
  );
}